"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[708],{

/***/ 862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ BaseFetcher; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50853);
/* harmony import */ var _kernel_DomainError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11455);
/* harmony import */ var _kernel_ErrorsCode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65694);









var BaseFetcher = /*#__PURE__*/ function() {
    "use strict";
    function BaseFetcher(config, token) {
        var _this = this;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, BaseFetcher);
        this.config = config;
        this.token = token;
        this.mapper = function(url) {
            return url;
        };
        var _this1 = this;
        this.get = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(url) {
                var options, schemas, innerOptions;
                var _arguments = arguments;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    schemas = options.schemas, innerOptions = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(options, [
                        "schemas"
                    ]);
                    return [
                        2,
                        _this1.request(url, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, innerOptions), {
                            method: "get"
                        }), schemas)
                    ];
                });
            });
            return function(url) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this2 = this;
        this.del = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(url) {
                var options, schemas, innerOptions;
                var _arguments = arguments;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    schemas = options.schemas, innerOptions = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(options, [
                        "schemas"
                    ]);
                    return [
                        2,
                        _this2.request(url, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, innerOptions), {
                            method: "delete"
                        }), schemas)
                    ];
                });
            });
            return function(url) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this3 = this;
        this.post = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(url) {
                var options, schemas, innerOptions;
                var _arguments = arguments;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    schemas = options.schemas, innerOptions = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(options, [
                        "schemas"
                    ]);
                    return [
                        2,
                        _this3.request(url, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, innerOptions), {
                            method: "post"
                        }), schemas)
                    ];
                });
            });
            return function(url) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this4 = this;
        this.put = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(url) {
                var options, schemas, innerOptions;
                var _arguments = arguments;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    schemas = options.schemas, innerOptions = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(options, [
                        "schemas"
                    ]);
                    return [
                        2,
                        _this4.request(url, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, innerOptions), {
                            method: "put"
                        }), schemas)
                    ];
                });
            });
            return function(url) {
                return _ref.apply(this, arguments);
            };
        }();
        this.withAuth = function() {
            if (!_this.token) throw _kernel_DomainError__WEBPACK_IMPORTED_MODULE_0__/* .DomainError.withCodes */ .Z.withCodes(_kernel_ErrorsCode__WEBPACK_IMPORTED_MODULE_1__/* .ErrorsCode.MISSING_AUTH_TOKEN */ .v.MISSING_AUTH_TOKEN);
            // The intention of this method is to force it to be declarative
            // when we mark a request as authenticated, that's why we use
            // the property rename, forcing us to execute the method when
            // we want the request to be authenticated:
            _this.authToken = _this.token;
            return _this;
        };
        this.withAuthMapper = function(mapper) {
            try {
                if (_this.withAuth()) {
                    _this.mapper = mapper;
                }
            } catch (e) {
                _this.mapper = function(url) {
                    return url;
                };
            }
            return _this;
        };
    }
    var _proto = BaseFetcher.prototype;
    _proto.request = function request(url, options, schemas) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            var ref, ref1, queryString, queryParams, internalFetcher, resp, respCloned, ref2, textContent, json, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (url.includes("?") && !(schemas === null || schemas === void 0 ? void 0 : schemas.query)) throw _kernel_DomainError__WEBPACK_IMPORTED_MODULE_0__/* .DomainError.withCodes */ .Z.withCodes(_kernel_ErrorsCode__WEBPACK_IMPORTED_MODULE_1__/* .ErrorsCode.MISSING_QUERY_SCHEMA */ .v.MISSING_QUERY_SCHEMA) // prettier-ignore
                        ;
                        if ((options === null || options === void 0 ? void 0 : options.body) && !(schemas === null || schemas === void 0 ? void 0 : schemas.body)) throw _kernel_DomainError__WEBPACK_IMPORTED_MODULE_0__/* .DomainError.withCodes */ .Z.withCodes(_kernel_ErrorsCode__WEBPACK_IMPORTED_MODULE_1__/* .ErrorsCode.MISSING_BODY_SCHEMA */ .v.MISSING_BODY_SCHEMA) // prettier-ignore
                        ;
                        if (url.includes("?")) {
                            ;
                            queryString = url.split("?")[1];
                            queryParams = Object.fromEntries(new URLSearchParams(queryString).entries());
                            schemas === null || schemas === void 0 ? void 0 : (ref1 = schemas.query) === null || ref1 === void 0 ? void 0 : ref1.parse(queryParams);
                        }
                        if (options === null || options === void 0 ? void 0 : options.body) schemas === null || schemas === void 0 ? void 0 : (ref = schemas.body) === null || ref === void 0 ? void 0 : ref.parse(JSON.parse(options.body));
                        internalFetcher = _this.fetch();
                        return [
                            4,
                            internalFetcher(_this.mapper(url), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, options, _this.authToken && {
                                credentials: "include"
                            }), {
                                headers: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (options === null || options === void 0 ? void 0 : options.headers) || {}, {
                                    "Content-Type": "application/json; charset=utf-8"
                                }, _this.authToken && {
                                    cookie: "sfl_user=".concat(encodeURIComponent(_this.authToken))
                                })
                            }))
                        ];
                    case 1:
                        resp = _state.sent();
                        respCloned = resp.clone();
                        if (!resp.ok) throw respCloned;
                        return [
                            4,
                            Promise.all([
                                resp.text(),
                                respCloned.text()
                            ])
                        ];
                    case 2:
                        ref2 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"].apply */ .Z.apply(void 0, [
                            _state.sent(),
                            1
                        ]), textContent = ref2[0];
                        json = Boolean(textContent.length) && JSON.parse(textContent);
                        if (json && Object.keys(json).length !== 0 && !(schemas === null || schemas === void 0 ? void 0 : schemas.response)) throw _kernel_DomainError__WEBPACK_IMPORTED_MODULE_0__/* .DomainError.withCodes */ .Z.withCodes(_kernel_ErrorsCode__WEBPACK_IMPORTED_MODULE_1__/* .ErrorsCode.MISSING_RESPONSE_SCHEMA */ .v.MISSING_RESPONSE_SCHEMA) // prettier-ignore
                        ;
                        if (schemas === null || schemas === void 0 ? void 0 : schemas.response) schemas === null || schemas === void 0 ? void 0 : schemas.response.parse(json);
                        return [
                            2,
                            [
                                undefined,
                                json
                            ]
                        ];
                    case 3:
                        error = _state.sent();
                        return [
                            2,
                            [
                                error,
                                undefined
                            ]
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return BaseFetcher;
}();
BaseFetcher.AUTH_COOKIE_NAME = "sfl_user";


/***/ }),

/***/ 97081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ FactoryFetcher; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50853);
/* harmony import */ var _cookie_FactoryCookie__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65509);
/* harmony import */ var _kernel_Environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24880);
/* harmony import */ var _BaseFetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(862);







var FactoryFetcher = /*#__PURE__*/ function() {
    "use strict";
    function FactoryFetcher(config) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, FactoryFetcher);
        this.config = config;
    }
    var _proto = FactoryFetcher.prototype;
    _proto.fetcher = function fetcher() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            var isNode, token, _tmp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isNode = _kernel_Environment__WEBPACK_IMPORTED_MODULE_4__/* .Environment.create */ .q.create().isNode();
                        return [
                            4,
                            _this.getAuthToken()
                        ];
                    case 1:
                        token = _state.sent();
                        if (!isNode) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 8257).then(__webpack_require__.t.bind(__webpack_require__, 58257, 23))
                        ];
                    case 2:
                        _tmp = _state.sent().NodeFetcher.create({
                            config: _this.config,
                            token: token
                        });
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 6809).then(__webpack_require__.bind(__webpack_require__, 66809))
                        ];
                    case 4:
                        _tmp = _state.sent().WindowFetcher.create({
                            config: _this.config,
                            token: token
                        });
                        _state.label = 5;
                    case 5:
                        return [
                            2,
                            _tmp
                        ];
                }
            });
        })();
    };
    _proto.getAuthToken = function getAuthToken() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            var cookie, ref, token;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _cookie_FactoryCookie__WEBPACK_IMPORTED_MODULE_5__/* .FactoryCookie.create */ .f.create({
                                config: _this.config
                            }).cookie()
                        ];
                    case 1:
                        cookie = _state.sent();
                        ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(cookie.get({
                            key: _BaseFetcher__WEBPACK_IMPORTED_MODULE_0__/* .BaseFetcher.AUTH_COOKIE_NAME */ .p.AUTH_COOKIE_NAME
                        }), 2), token = ref[1];
                        return [
                            2,
                            token
                        ];
                }
            });
        })();
    };
    FactoryFetcher.create = function create(param) {
        var config = param.config;
        return new FactoryFetcher(config);
    };
    return FactoryFetcher;
}();


/***/ }),

/***/ 40708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PropertyRepositoryProxy; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_cookie/FactoryCookie.ts
var FactoryCookie = __webpack_require__(65509);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/DomainError.ts
var DomainError = __webpack_require__(11455);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/ErrorsCode.ts
var ErrorsCode = __webpack_require__(65694);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/ID.ts
var ID = __webpack_require__(86275);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27805);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(64468);
// EXTERNAL MODULE: ../../node_modules/zod/v3/types.js + 1 modules
var types = __webpack_require__(53538);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/architecture.ts
var architecture = __webpack_require__(70163);
;// CONCATENATED MODULE: ../../packages/stayforlong/src/_kernel/ListOfID.ts








var ListOfIDValidation = types/* object */.Ry({
    list: types/* instanceof */.Pp(ID.ID, {
        message: "[ListOfID] list is required"
    }).array()
});
var ListOfID = /*#__PURE__*/ function(Model) {
    "use strict";
    (0,_inherits/* default */.Z)(ListOfID, Model);
    var _super = (0,_create_super/* default */.Z)(ListOfID);
    function ListOfID(_list) {
        (0,_class_call_check/* default */.Z)(this, ListOfID);
        var _this;
        _this = _super.call(this);
        _this._list = _list;
        return _this;
    }
    var _proto = ListOfID.prototype;
    _proto.map = function map(fn) {
        return this._list.map(fn);
    };
    _proto.at = function at(param) {
        var position = param.position;
        return this._list.at(position);
    };
    _proto.findOne = function findOne(param) {
        var id = param.id;
        return this._list.find(function(item) {
            return item.value === id.value;
        });
    };
    _proto.addOne = function addOne(param) {
        var id = param.id, limit = param.limit;
        if (this.findOne({
            id: id
        })) {
            return this;
        }
        var newList = [
            id
        ].concat((0,_to_consumable_array/* default */.Z)(this._list));
        if (limit === undefined) {
            return ListOfID.create({
                list: newList
            });
        }
        return ListOfID.create({
            list: newList.slice(0, limit)
        });
    };
    _proto.removeOne = function removeOne(param) {
        var id = param.id;
        return ListOfID.create({
            list: this._list.filter(function(item) {
                return item.value !== id.value;
            })
        });
    };
    _proto.toString = function toString() {
        return this._list.map(function(item) {
            return item.value;
        }).join(",");
    };
    _proto.toJSON = function toJSON() {
        return {
            list: this._list.map(function(item) {
                return item.toJSON();
            })
        };
    };
    _proto.isEmpty = function isEmpty() {
        return this._list.length === 0;
    };
    ListOfID.create = function create(param) {
        var list = param.list;
        ListOfIDValidation.parse({
            list: list
        });
        return new ListOfID(list);
    };
    ListOfID.fromString = function fromString(param) {
        var ids = param.ids;
        return ListOfID.create({
            list: ids.split(",").map(function(id) {
                return ID.ID.create({
                    value: id
                });
            })
        });
    };
    ListOfID.empty = function empty() {
        return new ListOfID([]);
    };
    (0,_create_class/* default */.Z)(ListOfID, [
        {
            key: "list",
            get: function get() {
                return this._list;
            } // prettier-ignore
        },
        {
            key: "length",
            get: function get() {
                return this._list.length;
            } // prettier-ignore
        }
    ]);
    return ListOfID;
}(architecture/* Model */.H);

;// CONCATENATED MODULE: ../../packages/stayforlong/src/property/infrastructure/CookiePropertyRepository.ts









var CookiePropertyRepository = /*#__PURE__*/ function() {
    "use strict";
    function CookiePropertyRepository(config) {
        (0,_class_call_check/* default */.Z)(this, CookiePropertyRepository);
        this.config = config;
    }
    var _proto = CookiePropertyRepository.prototype;
    _proto.saveLastSeenIDs = function saveLastSeenIDs(param) {
        var ids = param.ids;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var cookie, ref, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryCookie/* FactoryCookie.create */.f.create({
                                config: _this.config
                            }).cookie()
                        ];
                    case 1:
                        cookie = _state.sent();
                        ref = (0,_sliced_to_array/* default */.Z)(cookie.save({
                            key: "vpid",
                            value: ids.toString()
                        }), 1), error = ref[0];
                        if (error) throw DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.ERROR_SAVING_LIST_LAST_SEEN_PROPERTIES */.v.ERROR_SAVING_LIST_LAST_SEEN_PROPERTIES);
                        return [
                            2,
                            ids
                        ];
                }
            });
        })();
    };
    _proto.lastSeenIDs = function lastSeenIDs() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var cookie, ref, error, ids, list;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryCookie/* FactoryCookie.create */.f.create({
                                config: _this.config
                            }).cookie()
                        ];
                    case 1:
                        cookie = _state.sent();
                        ref = (0,_sliced_to_array/* default */.Z)(cookie.get({
                            key: "vpid"
                        }), 2), error = ref[0], ids = ref[1];
                        if (error) return [
                            2,
                            ListOfID.empty()
                        ];
                        if (!ids) return [
                            2,
                            ListOfID.empty()
                        ];
                        list = ids.split(",").map(function(id) {
                            return ID.ID.create({
                                value: id
                            });
                        });
                        return [
                            2,
                            ListOfID.create({
                                list: list
                            })
                        ];
                }
            });
        })();
    };
    _proto.findByIDs = function findByIDs() {
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                throw DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.FORBIDDEN_REPOSITORY_METHOD */.v.FORBIDDEN_REPOSITORY_METHOD);
            });
        })();
    };
    _proto.findByBannerID = function findByBannerID() {
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                throw DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.FORBIDDEN_REPOSITORY_METHOD */.v.FORBIDDEN_REPOSITORY_METHOD);
            });
        })();
    };
    _proto.relatedByID = function relatedByID() {
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                throw DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.FORBIDDEN_REPOSITORY_METHOD */.v.FORBIDDEN_REPOSITORY_METHOD);
            });
        })();
    };
    _proto.saveLike = function saveLike() {
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                throw DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.FORBIDDEN_REPOSITORY_METHOD */.v.FORBIDDEN_REPOSITORY_METHOD);
            });
        })();
    };
    _proto.deleteLike = function deleteLike() {
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                throw DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.FORBIDDEN_REPOSITORY_METHOD */.v.FORBIDDEN_REPOSITORY_METHOD);
            });
        })();
    };
    _proto.isLiked = function isLiked() {
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                throw DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.FORBIDDEN_REPOSITORY_METHOD */.v.FORBIDDEN_REPOSITORY_METHOD);
            });
        })();
    };
    _proto.getUserLikesIds = function getUserLikesIds() {
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                throw DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.FORBIDDEN_REPOSITORY_METHOD */.v.FORBIDDEN_REPOSITORY_METHOD);
            });
        })();
    };
    _proto.getThemes = function getThemes() {
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                throw DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.FORBIDDEN_REPOSITORY_METHOD */.v.FORBIDDEN_REPOSITORY_METHOD);
            });
        })();
    };
    CookiePropertyRepository.create = function create(param) {
        var config = param.config;
        return new CookiePropertyRepository(config);
    };
    return CookiePropertyRepository;
}();

// EXTERNAL MODULE: ../../packages/stayforlong/src/_fetcher/FactoryFetcher.ts
var FactoryFetcher = __webpack_require__(97081);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/PaginationStatus.ts
var PaginationStatus = __webpack_require__(34418);
;// CONCATENATED MODULE: ../../packages/stayforlong/src/_kernel/ListOfPaginatedID.ts









var ListOfPaginatedIDValidation = types/* object */.Ry({
    paginationStatus: types/* instanceof */.Pp(PaginationStatus/* PaginationStatus */.z, {
        message: "pagination status is required"
    }),
    ids: types/* instanceof */.Pp(ListOfID, {
        message: "[ListOfPAginatedID] list is required"
    })
});
var ListOfPaginatedID = /*#__PURE__*/ function(Model) {
    "use strict";
    (0,_inherits/* default */.Z)(ListOfPaginatedID, Model);
    var _super = (0,_create_super/* default */.Z)(ListOfPaginatedID);
    function ListOfPaginatedID(_paginationStatus, _ids) {
        (0,_class_call_check/* default */.Z)(this, ListOfPaginatedID);
        var _this;
        _this = _super.call(this);
        _this._paginationStatus = _paginationStatus;
        _this._ids = _ids;
        return _this;
    }
    var _proto = ListOfPaginatedID.prototype;
    _proto.toJSON = function toJSON() {
        return {
            pagination: this._paginationStatus.toJSON(),
            ids: this._ids.toJSON()
        };
    };
    ListOfPaginatedID.create = function create(param) {
        var paginationStatus = param.paginationStatus, ids = param.ids;
        ListOfPaginatedIDValidation.parse({
            paginationStatus: paginationStatus,
            ids: ids
        });
        return new ListOfPaginatedID(paginationStatus, ids);
    };
    ListOfPaginatedID.fromLikesAPI = function fromLikesAPI(param) {
        var json = param.json;
        return ListOfPaginatedID.create({
            paginationStatus: PaginationStatus/* PaginationStatus.fromLikesAPI */.z.fromLikesAPI({
                json: json.pagination
            }),
            ids: ListOfID.create({
                list: json.properties.map(function(item) {
                    return ID.ID.fromNumber({
                        value: item.propertyId
                    });
                })
            })
        });
    };
    ListOfPaginatedID.empty = function empty() {
        return new ListOfPaginatedID(PaginationStatus/* PaginationStatus.empty */.z.empty(), ListOfID.empty());
    };
    (0,_create_class/* default */.Z)(ListOfPaginatedID, [
        {
            key: "paginationStatus",
            get: function get() {
                return this._paginationStatus;
            } // prettier-ignore
        },
        {
            key: "ids",
            get: function get() {
                return this._ids;
            } // prettier-ignore
        }
    ]);
    return ListOfPaginatedID;
}(architecture/* Model */.H);

// EXTERNAL MODULE: ../../packages/stayforlong/src/property/domain/ListOfProperty.ts
var ListOfProperty = __webpack_require__(87659);
// EXTERNAL MODULE: ../../packages/stayforlong/src/property/domain/ListOfTheme.ts + 1 modules
var ListOfTheme = __webpack_require__(44214);
// EXTERNAL MODULE: ../../packages/stayforlong/src/shared/domain/Language.ts
var Language = __webpack_require__(43491);
// EXTERNAL MODULE: ../../packages/stayforlong/src/shared/domain/Market.ts
var Market = __webpack_require__(14828);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/Name.ts
var Name = __webpack_require__(82634);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/Slug.ts
var Slug = __webpack_require__(30714);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/Address.ts
var Address = __webpack_require__(16525);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/Date.ts
var _kernel_Date = __webpack_require__(83209);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/Currency.ts
var Currency = __webpack_require__(8703);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/Country.ts
var Country = __webpack_require__(47498);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/Accommodation.ts
var Accommodation = __webpack_require__(38828);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/Stars.ts
var Stars = __webpack_require__(89689);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/Rating.ts
var Rating = __webpack_require__(34624);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/City.ts
var City = __webpack_require__(45317);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/GeoCoordenate.ts
var GeoCoordenate = __webpack_require__(22624);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/DistanceToCityCenter.ts
var DistanceToCityCenter = __webpack_require__(64490);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/NumberOfComments.ts
var NumberOfComments = __webpack_require__(26990);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/Money.ts
var Money = __webpack_require__(22816);
;// CONCATENATED MODULE: ../../packages/stayforlong/src/property/infrastructure/HTTPPropertyRepository/schemas/banner/index.ts

















var POSTBannerPropertiesBody = types/* object */.Ry({
    checkin: _kernel_Date/* DateValidation.shape.value */.Wq.shape.value,
    checkout: _kernel_Date/* DateValidation.shape.value */.Wq.shape.value,
    isFamiliar: types/* boolean */.O7().nullish(),
    rooms: types/* array */.IX(types/* object */.Ry({
        adults: types/* number */.Rx(),
        children: types/* array */.IX(types/* number */.Rx())
    })),
    sortBy: types/* string */.Z_().nullish(),
    lang: Language/* LanguageValidation.shape.value */._.shape.value,
    market: Market/* MarketValidation.shape.value */.iT.shape.value
});
var POSTBannerResponse = types/* object */.Ry({
    properties: types/* array */.IX(types/* object */.Ry({
        id: types/* number */.Rx(),
        name: Name/* NameValidation.shape.value */.C.shape.value,
        slug: Slug/* SlugValidation.shape.value */.g.shape.value,
        address: Address/* AddressValidation.shape.value */.S.shape.value,
        accommodation_type: Accommodation/* AccommodationValidation.shape.value */.Lz.shape.value,
        currency: Currency/* CurrencyValidation.shape.value */.$t.shape.value,
        stars: Stars/* StarsValidation.shape.value */.p.shape.value,
        rating: Rating/* RatingValidation.shape.value */.V.shape.value,
        comments: NumberOfComments/* NumberOfCommentsValidation.shape.value */.g.shape.value,
        selling_rate: Money/* MoneyValidation.shape.amount */.D.shape.amount,
        bighead_rate: Money/* MoneyValidation.shape.amount */.D.shape.amount,
        avg_rate: Money/* MoneyValidation.shape.amount */.D.shape.amount,
        distance: types/* object */.Ry({
            value: DistanceToCityCenter/* DistanceToCityCenterValidation.shape.value */.a.shape.value,
            unit: types/* string */.Z_()
        }),
        facilities: types/* array */.IX(types/* object */.Ry({
            code_group: types/* string */.Z_(),
            id: types/* string */.Z_()
        })),
        images: types/* array */.IX(types/* object */.Ry({
            bucket: types/* string */.Z_(),
            path: types/* string */.Z_(),
            code: types/* string */.Z_(),
            width: types/* number */.Rx(),
            height: types/* number */.Rx()
        })),
        rooms: types/* array */.IX(types/* object */.Ry({
            summary: types/* object */.Ry({
                subtotal: types/* object */.Ry({
                    amount: Money/* MoneyValidation.shape.amount */.D.shape.amount,
                    currency: Currency/* CurrencyValidation.shape.value */.$t.shape.value
                }),
                subtotal_nightly: types/* object */.Ry({
                    amount: Money/* MoneyValidation.shape.amount */.D.shape.amount,
                    currency: Currency/* CurrencyValidation.shape.value */.$t.shape.value
                }),
                total: types/* object */.Ry({
                    amount: Money/* MoneyValidation.shape.amount */.D.shape.amount,
                    currency: Currency/* CurrencyValidation.shape.value */.$t.shape.value
                }),
                total_nightly: types/* object */.Ry({
                    amount: Money/* MoneyValidation.shape.amount */.D.shape.amount,
                    currency: Currency/* CurrencyValidation.shape.value */.$t.shape.value
                }),
                total_with_fees: types/* object */.Ry({
                    amount: Money/* MoneyValidation.shape.amount */.D.shape.amount,
                    currency: Currency/* CurrencyValidation.shape.value */.$t.shape.value
                }),
                total_nightly_with_fees: types/* object */.Ry({
                    amount: Money/* MoneyValidation.shape.amount */.D.shape.amount,
                    currency: Currency/* CurrencyValidation.shape.value */.$t.shape.value
                }),
                additional_fees: types/* object */.Ry({
                    amount: Money/* MoneyValidation.shape.amount */.D.shape.amount,
                    currency: Currency/* CurrencyValidation.shape.value */.$t.shape.value
                }),
                subtotal_with_fees: types/* object */.Ry({
                    amount: Money/* MoneyValidation.shape.amount */.D.shape.amount,
                    currency: Currency/* CurrencyValidation.shape.value */.$t.shape.value
                }),
                subtotal_nightly_with_fees: types/* object */.Ry({
                    amount: Money/* MoneyValidation.shape.amount */.D.shape.amount,
                    currency: Currency/* CurrencyValidation.shape.value */.$t.shape.value
                })
            })
        })).min(1),
        property_location: types/* object */.Ry({
            city: City/* CityValidation.shape.value */.Q.shape.value,
            city_slug: Slug/* SlugValidation.shape.value */.g.shape.value,
            country: types/* string */.Z_(),
            country_code: Country/* CountryValidation.shape.value */.kY.shape.value,
            id_location: types/* string */.Z_(),
            coordinates: types/* object */.Ry({
                lat: GeoCoordenate/* GeoCoordinateValidation.shape.latitude */.f.shape.latitude,
                lon: GeoCoordenate/* GeoCoordinateValidation.shape.longitude */.f.shape.longitude
            })
        })
    }))
});

// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/Path.ts
var Path = __webpack_require__(17043);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/ImageBucket.ts
var ImageBucket = __webpack_require__(99042);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/ImageSize.ts
var ImageSize = __webpack_require__(42929);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/ImageCode.ts
var ImageCode = __webpack_require__(45489);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/ImageCategoryOrder.ts
var ImageCategoryOrder = __webpack_require__(49930);
;// CONCATENATED MODULE: ../../packages/stayforlong/src/property/infrastructure/HTTPPropertyRepository/schemas/properties/ids/index.ts



















var GETpropertiesByIDsQuery = types/* object */.Ry({
    lang: Language/* LanguageValidation.shape.value */._.shape.value,
    id_properties: types/* string */.Z_().regex(/^[^,]+(?:,[^,]+)*$/)
});
var GETpropertiesByIDsResponse = types/* object */.Ry({
    properties: types/* object */.Ry({
        id_property: types/* number */.Rx().min(0),
        name: Name/* NameValidation.shape.value */.C.shape.value,
        country: Country/* CountryValidation.shape.value */.kY.shape.value,
        slug: Slug/* SlugValidation.shape.value */.g.shape.value,
        accommodation_type: Accommodation/* AccommodationValidation.shape.value */.Lz.shape.value,
        latitude: GeoCoordenate/* GeoCoordinateValidation.shape.latitude */.f.shape.latitude,
        longitude: GeoCoordenate/* GeoCoordinateValidation.shape.longitude */.f.shape.longitude,
        address: Address/* AddressValidation.shape.value */.S.shape.value,
        city: City/* CityValidation.shape.value */.Q.shape.value,
        stars: Stars/* StarsValidation.shape.value */.p.shape.value,
        distance: DistanceToCityCenter/* DistanceToCityCenterValidation.shape.value.nullable */.a.shape.value.nullable().optional(),
        in_center: types/* boolean */.O7().nullable().optional().default(false),
        city_slug: Slug/* SlugValidation.shape.value */.g.shape.value,
        rating: types/* union */.G0([
            Rating/* RatingValidation.shape.value */.V.shape.value,
            types/* string */.Z_()
        ]).optional(),
        facilities: types/* object */.Ry({}).array().optional(),
        rating_count: NumberOfComments/* NumberOfCommentsValidation.shape.value.optional */.g.shape.value.optional(),
        ratings: types/* object */.Ry({
            id_tripadvisor: ID/* IDValidation.shape.value.optional */.o.shape.value.optional(),
            rating: types/* union */.G0([
                types/* number */.Rx().min(0),
                types/* string */.Z_()
            ]).optional(),
            ranking_out_of: types/* number */.Rx().positive().optional(),
            ranking: types/* number */.Rx().positive().optional(),
            review_rating_count: types/* object */.Ry({
                rating: Rating/* RatingValidation.shape.value */.V.shape.value,
                recount: types/* number */.Rx().positive().optional()
            }).array().optional(),
            subratings: types/* object */.Ry({
                name: Name/* NameValidation.shape.value */.C.shape.value,
                value: Rating/* RatingValidation.shape.value */.V.shape.value,
                localized_name: types/* string */.Z_()
            }).array().optional(),
            trip_types: types/* object */.Ry({
                name: types/* string */.Z_(),
                value: types/* number */.Rx()
            }).array().optional(),
            rating_count: NumberOfComments/* NumberOfCommentsValidation.shape.value.optional */.g.shape.value.optional()
        }).optional(),
        images: types/* object */.Ry({
            path: Path/* PathValidation.shape.value */.L.shape.value,
            bucket: ImageBucket/* ImageBucketValidation.shape.value */.h.shape.value,
            width: ImageSize/* ImageSizeValidation.shape.width */.p.shape.width,
            height: ImageSize/* ImageSizeValidation.shape.height */.p.shape.height,
            code: ImageCode/* ImageCodeValidation.shape.value */.E.shape.value,
            categoryOrder: ImageCategoryOrder/* ImageCategoryOrderValidation.shape.value */.z.shape.value
        }).array()
    }).array()
});

// EXTERNAL MODULE: ../../packages/stayforlong/src/shared/domain/Affiliate.ts
var Affiliate = __webpack_require__(54429);
;// CONCATENATED MODULE: ../../packages/stayforlong/src/property/infrastructure/HTTPPropertyRepository/schemas/related/index.ts


















var POSTRelatedBody = types/* object */.Ry({
    idProperty: types/* number */.Rx(),
    lang: Language/* LanguageValidation.shape.value */._.shape.value,
    market: Market/* MarketValidation.shape.value */.iT.shape.value,
    rooms: types/* array */.IX(types/* object */.Ry({
        adults: types/* number */.Rx(),
        children: types/* array */.IX(types/* number */.Rx())
    })),
    checkin: _kernel_Date/* DateValidation.shape.value */.Wq.shape.value,
    checkout: _kernel_Date/* DateValidation.shape.value */.Wq.shape.value,
    affiliate: Affiliate/* AffiliateValidation.shape.value */.ei.shape.value,
    country: Country/* CountryValidation.shape.value */.kY.shape.value,
    currency: Currency/* CurrencyValidation.shape.value */.$t.shape.value,
    source: types/* string */.Z_()
});
var POSTRelatedResponse = types/* object */.Ry({
    properties: types/* array */.IX(types/* object */.Ry({
        id: types/* number */.Rx(),
        name: Name/* NameValidation.shape.value */.C.shape.value,
        slug: Slug/* SlugValidation.shape.value */.g.shape.value,
        address: Address/* AddressValidation.shape.value */.S.shape.value,
        accommodation_type: Accommodation/* AccommodationValidation.shape.value */.Lz.shape.value,
        currency: Currency/* CurrencyValidation.shape.value */.$t.shape.value,
        stars: Stars/* StarsValidation.shape.value */.p.shape.value,
        rating: Rating/* RatingValidation.shape.value */.V.shape.value,
        comments: NumberOfComments/* NumberOfCommentsValidation.shape.value */.g.shape.value,
        selling_rate: Money/* MoneyValidation.shape.amount */.D.shape.amount,
        bighead_rate: Money/* MoneyValidation.shape.amount */.D.shape.amount,
        avg_rate: Money/* MoneyValidation.shape.amount */.D.shape.amount,
        distance: types/* object */.Ry({
            value: DistanceToCityCenter/* DistanceToCityCenterValidation.shape.value */.a.shape.value,
            unit: types/* string */.Z_()
        }),
        facilities: types/* array */.IX(types/* object */.Ry({
            code_group: types/* string */.Z_(),
            id: types/* string */.Z_()
        })),
        images: types/* array */.IX(types/* object */.Ry({
            bucket: types/* string */.Z_(),
            path: types/* string */.Z_(),
            code: types/* string */.Z_(),
            width: types/* number */.Rx(),
            height: types/* number */.Rx()
        })),
        rooms: types/* array */.IX(types/* object */.Ry({
            summary: types/* object */.Ry({
                subtotal: types/* object */.Ry({
                    amount: Money/* MoneyValidation.shape.amount */.D.shape.amount,
                    currency: Currency/* CurrencyValidation.shape.value */.$t.shape.value
                }),
                subtotal_nightly: types/* object */.Ry({
                    amount: Money/* MoneyValidation.shape.amount */.D.shape.amount,
                    currency: Currency/* CurrencyValidation.shape.value */.$t.shape.value
                }),
                total: types/* object */.Ry({
                    amount: Money/* MoneyValidation.shape.amount */.D.shape.amount,
                    currency: Currency/* CurrencyValidation.shape.value */.$t.shape.value
                }),
                total_nightly: types/* object */.Ry({
                    amount: Money/* MoneyValidation.shape.amount */.D.shape.amount,
                    currency: Currency/* CurrencyValidation.shape.value */.$t.shape.value
                }),
                total_with_fees: types/* object */.Ry({
                    amount: Money/* MoneyValidation.shape.amount */.D.shape.amount,
                    currency: Currency/* CurrencyValidation.shape.value */.$t.shape.value
                }),
                total_nightly_with_fees: types/* object */.Ry({
                    amount: Money/* MoneyValidation.shape.amount */.D.shape.amount,
                    currency: Currency/* CurrencyValidation.shape.value */.$t.shape.value
                }),
                additional_fees: types/* object */.Ry({
                    amount: Money/* MoneyValidation.shape.amount */.D.shape.amount,
                    currency: Currency/* CurrencyValidation.shape.value */.$t.shape.value
                }),
                subtotal_with_fees: types/* object */.Ry({
                    amount: Money/* MoneyValidation.shape.amount */.D.shape.amount,
                    currency: Currency/* CurrencyValidation.shape.value */.$t.shape.value
                }),
                subtotal_nightly_with_fees: types/* object */.Ry({
                    amount: Money/* MoneyValidation.shape.amount */.D.shape.amount,
                    currency: Currency/* CurrencyValidation.shape.value */.$t.shape.value
                })
            })
        })).min(1),
        property_location: types/* object */.Ry({
            city: City/* CityValidation.shape.value */.Q.shape.value,
            city_slug: Slug/* SlugValidation.shape.value */.g.shape.value,
            country: types/* string */.Z_(),
            country_code: Country/* CountryValidation.shape.value */.kY.shape.value,
            id_location: types/* string */.Z_(),
            coordinates: types/* object */.Ry({
                lat: GeoCoordenate/* GeoCoordinateValidation.shape.latitude */.f.shape.latitude,
                lon: GeoCoordenate/* GeoCoordinateValidation.shape.longitude */.f.shape.longitude
            })
        })
    }))
});

// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/PageNumber.ts
var PageNumber = __webpack_require__(81378);
;// CONCATENATED MODULE: ../../packages/stayforlong/src/property/infrastructure/HTTPPropertyRepository/schemas/user-engagement/user/likes/index.ts


var GETLikesPropertiesQuery = types/* object */.Ry({
    limit: types/* string */.Z_(),
    page: types/* string */.Z_()
});
var GETLikesPropertiesResponse = types/* object */.Ry({
    pagination: types/* object */.Ry({
        total: PageNumber/* PageNumberValidation.shape.value */.G.shape.value,
        last: PageNumber/* PageNumberValidation.shape.value */.G.shape.value,
        page: PageNumber/* PageNumberValidation.shape.value */.G.shape.value
    }),
    properties: types/* object */.Ry({
        propertyId: types/* number */.Rx()
    }).array()
});

;// CONCATENATED MODULE: ../../packages/stayforlong/src/property/domain/LikeBelong.ts






var LikeBelongValidation = types/* object */.Ry({
    value: types/* boolean */.O7({
        required_error: "value is required"
    })
});
var LikeBelong = /*#__PURE__*/ function(Model) {
    "use strict";
    (0,_inherits/* default */.Z)(LikeBelong, Model);
    var _super = (0,_create_super/* default */.Z)(LikeBelong);
    function LikeBelong(_value) {
        (0,_class_call_check/* default */.Z)(this, LikeBelong);
        var _this;
        _this = _super.call(this);
        _this._value = _value;
        return _this;
    }
    var _proto = LikeBelong.prototype;
    _proto.isLiked = function isLiked() {
        return this.value;
    };
    _proto.toJSON = function toJSON() {
        return {
            value: this.value
        };
    };
    LikeBelong.create = function create(param) {
        var value = param.value;
        LikeBelongValidation.parse({
            value: value
        });
        return new LikeBelong(value);
    };
    (0,_create_class/* default */.Z)(LikeBelong, [
        {
            key: "value",
            get: function get() {
                return this._value;
            } // prettier-ignore
        }
    ]);
    return LikeBelong;
}(architecture/* Model */.H);

;// CONCATENATED MODULE: ../../packages/stayforlong/src/property/infrastructure/HTTPPropertyRepository/schemas/properties/:id/like/index.ts

var GetUserLikesPropertyResponse = types/* object */.Ry({
    propertyId: types/* number */.Rx().optional().nullable()
}).nullable();

;// CONCATENATED MODULE: ../../packages/stayforlong/src/property/infrastructure/HTTPPropertyRepository/schemas/themes/index.ts


var GETThemesQuery = types/* object */.Ry({
    language: Language/* LanguageValidation.shape.value */._.shape.value
});
var GETThemesResponse = types/* object */.Ry({
    themes: types/* object */.Ry({
        name: types/* string */.Z_(),
        slug: types/* string */.Z_()
    }).array()
});

;// CONCATENATED MODULE: ../../packages/stayforlong/src/property/infrastructure/HTTPPropertyRepository/index.ts

















var HTTPPropertyRepository = /*#__PURE__*/ function() {
    "use strict";
    function HTTPPropertyRepository(config) {
        (0,_class_call_check/* default */.Z)(this, HTTPPropertyRepository);
        this.config = config;
    }
    var _proto = HTTPPropertyRepository.prototype;
    _proto.saveLastSeenIDs = function saveLastSeenIDs() {
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                throw DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.FORBIDDEN_REPOSITORY_METHOD */.v.FORBIDDEN_REPOSITORY_METHOD);
            });
        })();
    };
    _proto.lastSeenIDs = function lastSeenIDs() {
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                throw DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.FORBIDDEN_REPOSITORY_METHOD */.v.FORBIDDEN_REPOSITORY_METHOD);
            });
        })();
    };
    _proto.findByIDs = function findByIDs(param) {
        var ids = param.ids, lang = param.lang;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var fetcher, API_GATEWAY, ref, err, json;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (ids.isEmpty()) {
                            return [
                                2,
                                ListOfProperty/* ListOfProperty.empty */.D.empty()
                            ];
                        }
                        return [
                            4,
                            FactoryFetcher/* FactoryFetcher.create */.$.create({
                                config: _this.config
                            }).fetcher()
                        ];
                    case 1:
                        fetcher = _state.sent();
                        API_GATEWAY = _this.config.get("API_GATEWAY");
                        return [
                            4,
                            fetcher.get("".concat(API_GATEWAY, "/v3/properties/ids?id_properties=").concat(ids, "&lang=").concat(lang.value), {
                                schemas: {
                                    response: GETpropertiesByIDsResponse,
                                    query: GETpropertiesByIDsQuery
                                }
                            })
                        ];
                    case 2:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), err = ref[0], json = ref[1];
                        if (err) throw DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.FIND_BY_IDS_PROPERTIES_NOT_FOUND */.v.FIND_BY_IDS_PROPERTIES_NOT_FOUND).withCauses(err);
                        return [
                            2,
                            ListOfProperty/* ListOfProperty.fromAPI */.D.fromAPI({
                                json: json
                            })
                        ];
                }
            });
        })();
    };
    _proto.findByBannerID = function findByBannerID(param) {
        var id = param.id, lang = param.lang, market = param.market, partialSearch = param.partialSearch, affiliate = param.affiliate;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var fetcher, API_GATEWAY, body, ref, err, json;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryFetcher/* FactoryFetcher.create */.$.create({
                                config: _this.config
                            }).fetcher()
                        ];
                    case 1:
                        fetcher = _state.sent();
                        API_GATEWAY = _this.config.get("API_GATEWAY");
                        body = {
                            checkin: partialSearch === null || partialSearch === void 0 ? void 0 : partialSearch.checkIn,
                            checkout: partialSearch === null || partialSearch === void 0 ? void 0 : partialSearch.checkOut,
                            isFamiliar: false,
                            rooms: partialSearch === null || partialSearch === void 0 ? void 0 : partialSearch.toJSON().paxes,
                            sortBy: "distance",
                            lang: lang.value,
                            market: market.value
                        };
                        return [
                            4,
                            fetcher.post("".concat(API_GATEWAY, "/v2/banners/").concat(id.value, "/properties"), {
                                schemas: {
                                    response: POSTBannerResponse,
                                    body: POSTBannerPropertiesBody
                                },
                                body: JSON.stringify(body)
                            })
                        ];
                    case 2:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), err = ref[0], json = ref[1];
                        if (err) throw DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.FIND_BY_BANNER_ID_PROPERTIES_NOT_FOUND */.v.FIND_BY_BANNER_ID_PROPERTIES_NOT_FOUND);
                        return [
                            2,
                            ListOfProperty/* ListOfProperty.fromBannerApi */.D.fromBannerApi({
                                json: json,
                                affiliate: affiliate,
                                market: market
                            })
                        ];
                }
            });
        })();
    };
    _proto.relatedByID = function relatedByID(param) {
        var id = param.id, lang = param.lang, market = param.market, partialSearch = param.partialSearch, affiliate = param.affiliate, currency = param.currency, country = param.country;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var fetcher, API_GATEWAY, body, ref, err, json;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryFetcher/* FactoryFetcher.create */.$.create({
                                config: _this.config
                            }).fetcher()
                        ];
                    case 1:
                        fetcher = _state.sent();
                        API_GATEWAY = _this.config.get("API_GATEWAY");
                        body = {
                            idProperty: +id.value,
                            lang: lang.value,
                            market: market.value,
                            rooms: partialSearch === null || partialSearch === void 0 ? void 0 : partialSearch.toJSON().paxes,
                            checkin: partialSearch === null || partialSearch === void 0 ? void 0 : partialSearch.checkIn,
                            checkout: partialSearch === null || partialSearch === void 0 ? void 0 : partialSearch.checkOut,
                            affiliate: affiliate === null || affiliate === void 0 ? void 0 : affiliate.value,
                            country: country.value,
                            currency: currency.value,
                            source: "web"
                        };
                        return [
                            4,
                            fetcher.withAuthMapper(function(url) {
                                return "".concat(url, "/member");
                            }).post("".concat(API_GATEWAY, "/v3/related"), {
                                schemas: {
                                    response: POSTRelatedResponse,
                                    body: POSTRelatedBody
                                },
                                body: JSON.stringify(body)
                            })
                        ];
                    case 2:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), err = ref[0], json = ref[1];
                        if (err) throw DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.RELATED_PROPERTIES_NOT_FOUND */.v.RELATED_PROPERTIES_NOT_FOUND).withCauses(err);
                        return [
                            2,
                            ListOfProperty/* ListOfProperty.fromRelatedAPI */.D.fromRelatedAPI({
                                json: json,
                                affiliate: affiliate,
                                market: market
                            })
                        ];
                }
            });
        })();
    };
    _proto.saveLike = function saveLike(param) {
        var id = param.id;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var fetcher, API_GATEWAY, ref, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryFetcher/* FactoryFetcher.create */.$.create({
                                config: _this.config
                            }).fetcher()
                        ];
                    case 1:
                        fetcher = _state.sent();
                        API_GATEWAY = _this.config.get("API_GATEWAY");
                        return [
                            4,
                            fetcher.withAuth().post("".concat(API_GATEWAY, "/user-engagement/properties/").concat(id.value, "/like"))
                        ];
                    case 2:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            1
                        ]), err = ref[0];
                        if (err) throw DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.ERROR_SAVING_PROPERTY_LIKE */.v.ERROR_SAVING_PROPERTY_LIKE).withCauses(err);
                        return [
                            2,
                            id
                        ];
                }
            });
        })();
    };
    _proto.deleteLike = function deleteLike(param) {
        var id = param.id;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var fetcher, API_GATEWAY, ref, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryFetcher/* FactoryFetcher.create */.$.create({
                                config: _this.config
                            }).fetcher()
                        ];
                    case 1:
                        fetcher = _state.sent();
                        API_GATEWAY = _this.config.get("API_GATEWAY");
                        return [
                            4,
                            fetcher.withAuth().del("".concat(API_GATEWAY, "/user-engagement/properties/").concat(id.value, "/like"))
                        ];
                    case 2:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            1
                        ]), err = ref[0];
                        if (err) throw DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.ERROR_DELETING_PROPERTY_LIKE */.v.ERROR_DELETING_PROPERTY_LIKE).withCauses(err);
                        return [
                            2,
                            id
                        ];
                }
            });
        })();
    };
    _proto.isLiked = function isLiked(param) {
        var id = param.id;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var fetcher, API_GATEWAY, ref, err, json;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryFetcher/* FactoryFetcher.create */.$.create({
                                config: _this.config
                            }).fetcher()
                        ];
                    case 1:
                        fetcher = _state.sent();
                        API_GATEWAY = _this.config.get("API_GATEWAY");
                        return [
                            4,
                            fetcher.withAuth().get("".concat(API_GATEWAY, "/user-engagement/properties/").concat(id.value, "/like"), {
                                schemas: {
                                    response: GetUserLikesPropertyResponse
                                }
                            })
                        ];
                    case 2:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), err = ref[0], json = ref[1];
                        if (err) throw DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.ERROR_GETTING_PROPERTY_LIKE */.v.ERROR_GETTING_PROPERTY_LIKE).withCauses(err);
                        if (!json) return [
                            2,
                            LikeBelong.create({
                                value: false
                            })
                        ];
                        return [
                            2,
                            LikeBelong.create({
                                value: true
                            })
                        ];
                }
            });
        })();
    };
    _proto.getUserLikesIds = function getUserLikesIds(param) {
        var pagination = param.pagination;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var fetcher, API_GATEWAY, ref, err, json;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryFetcher/* FactoryFetcher.create */.$.create({
                                config: _this.config
                            }).fetcher()
                        ];
                    case 1:
                        fetcher = _state.sent();
                        API_GATEWAY = _this.config.get("API_GATEWAY");
                        return [
                            4,
                            fetcher.withAuth().get("".concat(API_GATEWAY, "/user-engagement/user/likes?page=").concat(pagination.offset, "&limit=").concat(pagination.limit), {
                                schemas: {
                                    response: GETLikesPropertiesResponse,
                                    query: GETLikesPropertiesQuery
                                }
                            })
                        ];
                    case 2:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), err = ref[0], json = ref[1];
                        if (err) throw DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.ERROR_GETTING_PROPERTY_LIKES */.v.ERROR_GETTING_PROPERTY_LIKES).withCauses(err);
                        if (!json) return [
                            2,
                            ListOfPaginatedID.empty()
                        ];
                        return [
                            2,
                            ListOfPaginatedID.fromLikesAPI({
                                json: json
                            })
                        ];
                }
            });
        })();
    };
    _proto.getThemes = function getThemes(param) {
        var lang = param.lang;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var fetcher, API_GATEWAY, ref, err, json;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            FactoryFetcher/* FactoryFetcher.create */.$.create({
                                config: _this.config
                            }).fetcher()
                        ];
                    case 1:
                        fetcher = _state.sent();
                        API_GATEWAY = _this.config.get("API_GATEWAY");
                        return [
                            4,
                            fetcher.get("".concat(API_GATEWAY, "/v1/themes?language=").concat(lang.value), {
                                schemas: {
                                    response: GETThemesResponse,
                                    query: GETThemesQuery
                                }
                            })
                        ];
                    case 2:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), err = ref[0], json = ref[1];
                        if (err) {
                            throw DomainError/* DomainError.withCodes */.Z.withCodes(ErrorsCode/* ErrorsCode.ERROR_GETTING_THEMES */.v.ERROR_GETTING_THEMES).withCauses(err);
                        }
                        if (!json || !json.themes || json.themes.length === 0) {
                            return [
                                2,
                                ListOfTheme/* ListOfTheme.empty */.G.empty()
                            ];
                        }
                        return [
                            2,
                            ListOfTheme/* ListOfTheme.fromAPI */.G.fromAPI({
                                json: json
                            })
                        ];
                }
            });
        })();
    };
    HTTPPropertyRepository.create = function create(param) {
        var config = param.config;
        return new HTTPPropertyRepository(config);
    };
    return HTTPPropertyRepository;
}();

;// CONCATENATED MODULE: ../../packages/stayforlong/src/property/infrastructure/PropertyRepositoryProxy.ts





var PropertyRepositoryProxy = /*#__PURE__*/ function() {
    "use strict";
    function PropertyRepositoryProxy(remote, local) {
        (0,_class_call_check/* default */.Z)(this, PropertyRepositoryProxy);
        this.remote = remote;
        this.local = local;
    }
    var _proto = PropertyRepositoryProxy.prototype;
    _proto.saveLastSeenIDs = function saveLastSeenIDs(param) {
        var ids = param.ids;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    _this.local.saveLastSeenIDs({
                        ids: ids
                    })
                ];
            });
        })();
    };
    _proto.lastSeenIDs = function lastSeenIDs() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    _this.local.lastSeenIDs()
                ];
            });
        })();
    };
    _proto.findByIDs = function findByIDs(param) {
        var ids = param.ids, lang = param.lang;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    _this.remote.findByIDs({
                        ids: ids,
                        lang: lang
                    })
                ];
            });
        })();
    };
    _proto.findByBannerID = function findByBannerID(param) {
        var id = param.id, lang = param.lang, market = param.market, partialSearch = param.partialSearch, affiliate = param.affiliate;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    _this.remote.findByBannerID({
                        id: id,
                        lang: lang,
                        market: market,
                        partialSearch: partialSearch,
                        affiliate: affiliate
                    })
                ];
            });
        })();
    };
    _proto.relatedByID = function relatedByID(param) {
        var id = param.id, lang = param.lang, market = param.market, partialSearch = param.partialSearch, affiliate = param.affiliate, currency = param.currency, country = param.country;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    _this.remote.relatedByID({
                        id: id,
                        lang: lang,
                        market: market,
                        partialSearch: partialSearch,
                        affiliate: affiliate,
                        currency: currency,
                        country: country
                    })
                ];
            });
        })();
    };
    _proto.saveLike = function saveLike(param) {
        var id = param.id;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    _this.remote.saveLike({
                        id: id
                    })
                ];
            });
        })();
    };
    _proto.deleteLike = function deleteLike(param) {
        var id = param.id;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    _this.remote.deleteLike({
                        id: id
                    })
                ];
            });
        })();
    };
    _proto.isLiked = function isLiked(param) {
        var id = param.id;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    _this.remote.isLiked({
                        id: id
                    })
                ];
            });
        })();
    };
    _proto.getUserLikesIds = function getUserLikesIds(param) {
        var pagination = param.pagination;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    _this.remote.getUserLikesIds({
                        pagination: pagination
                    })
                ];
            });
        })();
    };
    _proto.getThemes = function getThemes(param) {
        var lang = param.lang;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    _this.remote.getThemes({
                        lang: lang
                    })
                ];
            });
        })();
    };
    PropertyRepositoryProxy.create = function create(param) {
        var config = param.config;
        return new PropertyRepositoryProxy(HTTPPropertyRepository.create({
            config: config
        }), CookiePropertyRepository.create({
            config: config
        }));
    };
    return PropertyRepositoryProxy;
}();


/***/ })

}]);